import { ISearchPage, IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";


export interface IKerwordsTypeDetails {
    "id": string,  // "关键分类id",
    "name": string,  // "分类名称",
    "status": string | number,  // "分类状态"
}

export interface IKerwordsTypeSeachFields {

}

export interface IKerwordsTypeSearch extends
    IKerwordsTypeSeachFields, ISearchPage {

}
export interface IKerwordsTypeInsert {
    "name": string,  // "分类名称",
    "status": string | number,  // "分类状态"
}


export interface IKerwordsDetails {
    "id": string,      // "关键分类id",
    "name": string,      // "分类名称",
    "status": string | number,      // "分类状态",
    "weight": number,      // "权重",
    "keywordTypeId": string,      // "所属分类id",
    "keywordTypeName": string,      // "所属分类名称",
}

export interface IKerwordsSeachFields {
    name?: string
}

export interface IKerwordsSearch extends
    IKerwordsSeachFields, ISearchPage {

}
export interface IKerwordsInsert {
    "name": string,   /// "关键词名称",
    "status": string | number,   /// "关键词状态",
    "weight": number,   /// "权重",
    "keywordTypeId": string,   /// "所属分类id",
    "keywordTypeName": string,   /// "所属分类名称",
}

class KeyWordsService {
    /*关键词分类列表*/
    async pageType(searchVo: IKerwordsTypeSearch) {
        const apiUrl = "/keywordType/page";
        return await httpRequest.post<IPage<IKerwordsTypeDetails>>(apiUrl, searchVo);
    }
    //禁用
    async disableType(id: string, status: string | number) {
        const apiUrl = `/keywordType/disable/${id}/${status}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //删除
    async removeType(id: string) {
        const apiUrl = `/keywordType/remove/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async insertType(insert: IKerwordsTypeInsert) {
        const apiUrl = "/keywordType/insert";
        return await httpRequest.post<boolean>(apiUrl, insert);
    }
    async updataType(update: IKerwordsTypeDetails) {
        const apiUrl = "/keywordType/update";
        return await httpRequest.post<boolean>(apiUrl, update);
    }


    /*关键词列表*/
    async page(searchVo: IKerwordsSearch) {
        const apiUrl = "/keyword/page";
        return await httpRequest.post<IPage<IKerwordsDetails>>(apiUrl, searchVo);
    }
    //禁用
    async disable(id: string, status: string | number) {
        const apiUrl = `/keyword/disable/${id}/${status}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    //删除
    async remove(id: string) {
        const apiUrl = `/keyword/remove/${id}`;
        return await httpRequest.get<boolean>(apiUrl);
    }
    async insert(insert: IKerwordsInsert) {
        const apiUrl = "/keyword/insert";
        return await httpRequest.post<boolean>(apiUrl, insert);
    }
    async updata(update: IKerwordsDetails) {
        const apiUrl = "/keyword/update";
        return await httpRequest.post<boolean>(apiUrl, update);
    }
}
export const keyWordsService = new KeyWordsService();